"use client";

import { JSX, useMemo } from "react";

import { useQuery } from "@apollo/client";
import { usePathname } from "next/navigation";
import Script from "next/script";

import { CAPTCHA_PAGES } from "@/constants/misc";
import { getRecaptchaKey } from "@/queries/customerpayments";

export default function Recaptcha(): JSX.Element {
  const pathname = usePathname();
  const isCheckout = pathname?.startsWith("/checkout");
  const { data } = useQuery(getRecaptchaKey, { skip: isCheckout });

  const enabled = data?.nutrafolRecaptchaV3?.enabled;
  const key = data?.nutrafolRecaptchaV3?.public_key;

  const useRecaptcha = useMemo(() => {
    if (isCheckout || !enabled || !key) return false;
    const lastPathSegment = pathname.split("/").filter(Boolean).slice(-1)[0];
    return Boolean(lastPathSegment) && CAPTCHA_PAGES.includes(lastPathSegment);
  }, [isCheckout, enabled, key, pathname]);

  if (!useRecaptcha) return null;

  return (
    <Script
      strategy="afterInteractive"
      id="grecaptchaV3"
      src={`https://www.google.com/recaptcha/api.js?render=${key}`}
    />
  );
}
